// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/azubi-event-oktober-2022/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const azubiEventOktober2022DE: PageEntry = {
  id: "post.azubi-event-oktober-2022",
  locale: "de",
  slug: "azubi-event-oktober-2022",
  seo: {
    title: "Azubi-Event 08.10.2022 | HSC 2000 Coburg | Dietz GmbH",
    description: "Azubi-Event 08.10.2022 | HSC 2000 Coburg",
  },
  type: "post",
  h1: "Azubi-Event 08.10.2022 | HSC 2000 Coburg",
  blocks: [
    { kind: "heading", level: 2, text: "Azubi-Event 08.10.2022 | HSC 2000 Coburg" },
    { kind: "paragraph", text: "Vergangenen Samstagnachmittag, am 08.10.2022, war es soweit: Das Azubi-Event in Kooperation mit dem HSC 2000 Coburg fand statt!" },
    { kind: "paragraph", text: "Nach der Begrüßung und einer Hallenführung wurde in der Veste Lounge gemeinsam zu Abend gegessen. Anschließend wurde sich auf das Spiel eingestimmt und auch ein Tippspiel durfte natürlich nicht fehlen. Der darauffolgende Spielbesuch des HSC 2000 Coburg vs. Eulen Ludwigshafen war ein absolutes Highlight. ✨ Während sich die Spieler in der Halbzeitpause befanden wurden unsere Azubis mit Fingerfood und Getränken verköstigt. Mit dem Meet & Green eines Wunschspielers und der Auswertung des Tippspiels endete ein durchweg gelungener Nachmittag und Abend. ☺️" },
    { kind: "paragraph", text: "Wir sind nachhaltig begeistert und danken allen Organisatoren für dieses Event." },
    { kind: "paragraph", text: "Dem HSC 2000 Coburg gratulieren wir zu einem grandiosen Spiel." }
  ],
};
